import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import usePosition from 'Components/Posistion';
import Box from '@material-ui/core/Box';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Button, Grid, Paper, Typography } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { EKYCSendOTP as EKYCSENDOTP } from 'Components/Api/OneClickAEPSAPI';
import { SelectProfile as USER_SELECT_BY_ID } from 'Components/Api/UsersApi';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import CircularProgress from '@material-ui/core/CircularProgress';
import HOCLoader from 'Components/Loader/HOCLoader';
import { useLocation } from 'react-router-dom';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
const CustomContainer = HOCLoader(Container);

export const OneClickSendOTP = () => {
    const history = useHistory();
    const classes = commonStyle();
    const { latitude, longitude } = usePosition();
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [formObject, setFormObject] = useState({
        AadhaarNo: '',
        MobileNo: '',
        PanNo: '',
        Latitude: latitude,
        Longitude: longitude
    });

    useEffect(() => {
        setLoading(true);
        SelectByID();
    }, []);

    const SelectByID = async () => {
        setLoading(true);

        const { isAuthorized, status, data } = await USER_SELECT_BY_ID();
        setLoading(false);

        if (!isAuthorized) LOGOUT();

        if (!status) return;

        var d = JSON.parse(data);
        setFormObject({
            PanNo: d.PANNo,
            AadhaarNo: d.AadharNo,
            MobileNo: d.MobileNumber
        });
    };
    const submithandle = async (values, { resetForm }) => {
        setResponseMessage('');
        setIsError(false);
        setLoading(true);
        const requestValues = {
            PanNo: values.PANNo,
            AadhaarNo: values.AadhaarNo,
            MobileNo: values.MobileNo,
            Latitude: latitude,
            Longitude: longitude
        };
        const requestObj = JSON.stringify(requestValues);
        var response = await EKYCSENDOTP(requestObj); 
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);
        setSeverity('success');
        if (!response.status) {
            var data = JSON.parse(response.data); 
            setResponseMessage(data.Message);
            setSeverity('error');
            if (data.Message === 'Ekyc already Verified') {
                history.push('/OCValidateOTP', {
                    latitude: latitude,
                    longitude: longitude,
                    EncodeFPTxnId: data.EncodeFPTxnId,
                    PrimaryKeyId: data.PrimaryKeyId,
                });
                return;
            }
            return;
        }

        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        if (data.Status === 'FAILURE') {
            setSeverity('error');
            setIsError(true);
            if (data.Message === 'User not onboarded') {
                history.push('/OCUserOnbording', {
                    latitude: latitude,
                    longitude: longitude
                });
                return;
            }
        }
        setResponseMessage(data.Message);
        let param = {
            MobileNo: values.MobileNo,
            EncodeFPTxnId: data.EncodeFPTxnId,
            PrimaryKeyId: data.PrimaryKeyId,
            PanNo: requestValues.PanNo,
            AadhaarNo: requestValues.AadhaarNo,
            Latitude: latitude,
            Longitude: longitude
        };
        history.push('/OCValidateOTP', param);
    };

    const FormValidationSchema = Yup.object({
        PanNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'PanNo'),
        AadhaarNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'AadhaarNo'),
        MobileNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'MobileNo')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        Ekyc Send OTP
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Pan Card"
                                                        name="PanNo"
                                                        type="text"
                                                        length={10}
                                                        placeholder="Pan Number"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Aadhaar No"
                                                        name="AadhaarNo"
                                                        type="text"
                                                        length={12}
                                                        placeholder="Aadhaar Number"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Mobile No"
                                                        name="MobileNo"
                                                        type="text"
                                                        length={10}
                                                        placeholder="Mobile Number"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Get OTP"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Get OTP
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        </CustomContainer>
    );
};
